import {customElement, property} from "lit/decorators.js";
import {FormInputElement} from "./formInputElement";
import {html, type TemplateResult} from "lit";
import {noop} from "../../../common/utils/functions";
import {trackingButtonInteract} from "../../../tracking/trackingAttributes";

@customElement("eop-form-toggle-link")
export class EopFormToggleLink extends FormInputElement<boolean> {

    @property({attribute: "label-check"})
    private labelCheck: string;
    @property({attribute: "label-uncheck"})
    private labelUncheck: string;

    public constructor() {
        super(false);
    }

    public render(): TemplateResult {
        return html`
            <button type="button" class="link detail-link" ${trackingButtonInteract(this.getLabel())} @click=${this.toggle}>
                <span>${this.getLabel()}</span>
            </button>`;
    }

    private toggle(event: Event): void {
        this.updateValue(!this.value);
    }

    private getLabel(): string {
        return this.value
            ? this.labelUncheck
            : this.labelCheck;
    }

    protected preset(): boolean {
        return false;
    }

    public focusInput(): void {
        noop();
    }
}